import {
  PARTICIPANT_ORDERS as SharedPARTICIPANT_ORDERS,
  EVENT_STATUSES as SharedEVENT_STATUSES,
  EVENT_REG_TYPES as SharedEVENT_REG_TYPES,
  EVENT_MEMBERGUEST_TYPES as SharedEVENT_MEMBERGUEST_TYPES,
  EVENT_TEAM_DEFINED_BY_TYPES as SharedEVENT_TEAM_DEFINED_BY_TYPES,
  PARTNERSHIP_DEFINED_BY_TYPES as SharedPARTNERSHIP_DEFINED_BY_TYPES,
  EVENT_COST_PAID_BY as SharedEVENT_COST_PAID_BY,
  ATTENDEE_OPTIONS as SharedATTENDEE_OPTIONS,
  ALL_ATTENDEE_OPTIONS as SharedALL_ATTENDEE_OPTIONS,
} from "shared/dist/types/Event";

import type {
  Event as SharedEvent,
  ParticipantOrder,
  EventRegType,
  EventStatus,
  EventMemberGuestType,
  EventTeamStructure,
  TeamDefinedByType,
  EventPartnership,
  PartnershipDefinedByType,
  CostPaidBy,
  AttendeeOption,
} from "shared/dist/types/Event";

export type {
  ParticipantOrder,
  EventRegType,
  EventStatus,
  EventMemberGuestType,
  EventTeamStructure,
  TeamDefinedByType,
  EventPartnership,
  PartnershipDefinedByType,
  CostPaidBy,
  AttendeeOption,
};

export const PARTICIPANT_ORDERS = SharedPARTICIPANT_ORDERS;
export const EVENT_STATUSES = SharedEVENT_STATUSES;
export const EVENT_REG_TYPES = SharedEVENT_REG_TYPES;
export const EVENT_MEMBERGUEST_TYPES = SharedEVENT_MEMBERGUEST_TYPES;
export const EVENT_TEAM_DEFINED_BY_TYPES = SharedEVENT_TEAM_DEFINED_BY_TYPES;
export const PARTNERSHIP_DEFINED_BY_TYPES = SharedPARTNERSHIP_DEFINED_BY_TYPES;
export const EVENT_COST_PAID_BY = SharedEVENT_COST_PAID_BY;
export const ATTENDEE_OPTIONS = SharedATTENDEE_OPTIONS;
export const ALL_ATTENDEE_OPTIONS = SharedALL_ATTENDEE_OPTIONS;

export default interface Event extends SharedEvent {}